import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useCart } from "@/context/CartContext";

const NAV = [
  { label: "Home", to: "/" },
  { label: "Shop", to: "/shop" },
  { label: "Popcorn", to: "/popcorn" },
  { label: "Cookies", to: "/cookies" },
  { label: "Cinnamon Pecans", to: "/cinnamon-pecans" },
  { label: "Track Order", to: "/track" },
  { label: "About", to: "/about" },
];

export function Header() {
  const { count, setDrawerOpen } = useCart();
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const nav = useNavigate();

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-md bg-obsidian/85 border-b border-gold/20"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16 sm:h-20">
        <button
          className="lg:hidden text-cream p-2 -ml-2"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>

        <Link to="/" className="lg:flex-none" data-testid="header-logo-link">
          <Logo />
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`text-sm tracking-wide transition-colors hover:text-gold ${
                loc.pathname === n.to ? "text-gold" : "text-cream/80"
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <button
          onClick={() => setDrawerOpen(true)}
          className="relative text-cream p-2 hover:text-gold transition-colors"
          data-testid="header-cart-button"
          aria-label="Cart"
        >
          <ShoppingBag size={24} />
          {count > 0 && (
            <span
              className="absolute -top-0.5 -right-0.5 btn-gold text-[10px] font-bold rounded-full h-5 w-5 flex items-center justify-center"
              data-testid="cart-count-badge"
            >
              {count}
            </span>
          )}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-gold/20 bg-obsidian/95 backdrop-blur-md" data-testid="mobile-menu">
          <div className="px-4 py-3 flex flex-col">
            {NAV.map((n) => (
              <button
                key={n.to}
                onClick={() => {
                  nav(n.to);
                  setOpen(false);
                }}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-left py-3 text-cream/90 border-b border-gold/10 last:border-0 hover:text-gold"
              >
                {n.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
